export default {"src":"/_next/static/media/interactive-engagement.1068c508.svg","height":248,"width":248,"blurWidth":0,"blurHeight":0};